import { useSelector } from 'react-redux';
import authRoles, { RolePermissionName } from '../auth/authRoles';
import { selectUser } from '../store/userSlice';

export function useIsPermissionAvailable(permissionName: RolePermissionName) {
  const user = useSelector(selectUser);
  return authRoles[permissionName].includes(user.role?.name as never);
}
